import React from "react";
import { routes } from "../../routes/routes";
import { isAccessLimitedByParentalLevel } from "../../services/parentalControlService";
import { isADMNRoute } from "../../utils/tvodUtils";

let isKidsThemed = false;

// FIXME: Having to check every possible case related to theming issues
// (and dealing with specific routes) should be avoided as well as theming
// management should be revisited.
/**
 * Checks corner cases related to kids theming.
 * @param {String} route
 * @param {String} referrer
 * @param {Boolean} isAccessLimitedByParentalLevel
 */
function isKidsThemedCornerCase(route, referrer, isAccessLimitedByParentalLevel) {
  // FIXME By definition, this code should not exist (given it is a corner case). Maybe we could use the subtheme capabilities to pass a function in the routes and make more complex logic
  return (
    /\/explore\/kids/.test(route) ||
    (isKidsThemed &&
      route &&
      route.search(/\/(login|search|splash|settings|parentalControl)/) !== 0 &&
      !/\/search/.test(referrer)) ||
    (/\/episodes/.test(route) && isAccessLimitedByParentalLevel)
  );
}

export function withSubtheme(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      WrappedComponent.defaultFocusPath && (this.defaultFocusPath = WrappedComponent.defaultFocusPath);
      WrappedComponent.name && (this.name = WrappedComponent.name);
    }

    checkRouteSubtheme(route, subtheme) {
      // const {
      //   applicationState: { userLogged },
      //   location
      // } = this.props;
      if (isADMNRoute(route)) {
        return "admn";
      }
      // if (/\/search/.test(route) || /\/mylibrary/.test(route)) {
      //   return userLogged && isAccessLimitedByParentalLevel() && "kids";
      // } else if (isKidsThemedCornerCase(route, location.referrer, isAccessLimitedByParentalLevel())) {
      //   return "kids";
      // }
      return (typeof subtheme === "function" && subtheme()) || subtheme;
    }

    /**
     * Stores a value to maintain kids theme or not.
     */
    checkRootTheming() {
      const { route } = this.props;
      const isKidsRoot = route === routes.kids;
      isKidsThemed = isKidsRoot;
    }

    componentDidMount() {
      const {
        route,
        subtheme,
        stateActions,
        location: { referrer, state }
      } = this.props;
      (referrer === routes.mylibrary || (state && state.deepLinkReferrer === true)) && (isKidsThemed = false);
      // FIXME: REVISIT. Try to find another way to overwrite subtheme or manage it.
      (this.props.isRoot || /\/search/.test(route)) && this.checkRootTheming();
      const subtheming = route && this.checkRouteSubtheme(route, subtheme);
      if (!subtheming) {
        stateActions.changeTheme(null);
      } else if (subtheming !== true) {
        stateActions.changeTheme(subtheming);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
